import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { MeasurementState } from '../../state/measurement.state';
import { CSS, Style } from './measurement.popup.style';
import { IkeUnit } from '@ikegps/core-shared';
import { Services } from '../../services';

addStyles(Style);

export interface MeasurementPopupConfig {
	onClose: () => void;
	onPauseChange?: () => void;
	measurementState: MeasurementState;
}

export const MeasurementPopup = {
	view(cfg: MeasurementPopupConfig): MithrilVNode {
		const isPaused = cfg.measurementState.isPaused;

		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.header }, [
				m('div', { className: CSS.title }, Translate(T.TOPO_TOOL_MEASURE)),
				m('div', { className: CSS.headerActions }, [
					ImageButton.view(isPaused ? MaterialIcon.PLAY_CIRCLE : MaterialIcon.PAUSE_CIRCLE, {
						onclick: () => {
							cfg.measurementState.setPaused(!isPaused);
							if (cfg.onPauseChange) cfg.onPauseChange();
						},
						title: isPaused ? T.MEASUREMENT_RESUME_TOOLTIP : T.MEASUREMENT_PAUSE_TOOLTIP,
					}),
					ImageButton.view(MaterialIcon.CLOSE, {
						onclick: cfg.onClose,
						title: T.CLOSE,
					}),
				]),
			]),
			m('div', { className: CSS.content }, [
				cfg.measurementState.points.length >= 2
					? m('div', [
							m('div', { className: CSS.measurementRow }, [
								m('div', { className: CSS.measurementLabel }, Translate(T.MEASUREMENT_RULING_SPAN)),
								m(
									'div',
									{ className: CSS.measurementValue },
									IkeUnit.display(cfg.measurementState.rulingSpan, Services.UserSettings.units)
								),
							]),
							m('div', { className: CSS.measurementRow }, [
								m('div', { className: CSS.measurementLabel }, Translate(T.MEASUREMENT_TOTAL_DISTANCE)),
								m(
									'div',
									{ className: CSS.measurementValue },
									IkeUnit.display(cfg.measurementState.totalDistance, Services.UserSettings.units)
								),
							]),
						])
					: m('div', { className: CSS.emptyState }, Translate(T.MEASUREMENT_EMPTY_STATE)),
			]),
		]);
	},
};
